import { App } from '@/App'
import { config } from '@/config'
import { initSWRegistration } from '@/modules/pwa/sw-update'
import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'

if (config.sentryDsn) {
  Sentry.init({
    dsn: config.sentryDsn,
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  })
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root was not found')
}

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  initSWRegistration()
  import('@/modules/pwa/sw-sync').then(({ registerQueueSync }) => {
    void registerQueueSync()
  })
  if (import.meta.env.DEV) {
    import('@/modules/pwa/sw-logger').then(({ initSWLogger }) => void initSWLogger())
  }
}

if (import.meta.env.DEV) {
  // XState actor registry + visual inspector
  import('@/utils/xstate-inspector')
    .then(({ initActorRegistry, initXStateInspector }) => {
      initActorRegistry()
      void initXStateInspector()
    })
    .catch(() => {})

  // Mobile DevTools: append ?debug to URL to activate (e.g. tunnel-url.com?debug)
  import('@/utils/dev-tools').then(({ initDevTools }) => void initDevTools()).catch(() => {})

  // Network request logging
  import('@/utils/fetch-logger')
    .then(({ installFetchLogger }) => installFetchLogger())
    .catch(() => {})
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
